module.exports = __webpack_public_path__ + "static/media/loading.ab2e44f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/loading.svg
// module id = 302
// module chunks = 0